<mat-dialog-content>
  <mat-toolbar color="primary" class="apearAnimation flex-row flex content-between relative rounded-md">
    <span class="font-semibold">Deportistas asignados al horario {{ data.nombre }}</span>

    <div fxFlex fxLayout="row" fxLayoutAlign="flex-end">
      <ul fxLayout="row" fxLayoutGap="20px">
        <li>
          <button mat-icon-button (click)="descargarReporte()">
            <mat-icon>file_download</mat-icon>
          </button>
        </li>
      </ul>
    </div>


  </mat-toolbar>

  <div class="margin-container apearAnimation">
    <div class="loading-indicator" *ngIf="isLoadingResults">
      <mat-spinner></mat-spinner>
    </div>

    <div class="mat-elevation-z0 contenedorTabla" *ngIf="!isLoadingResults">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="nombre">
          <th mat-header-cell *matHeaderCellDef>Nombre</th>
          <td mat-cell *matCellDef="let element">
            {{ element.nombre }}
            <br />
            <small>
              {{ element.documento }}
            </small>
          </td>
        </ng-container>

        <ng-container matColumnDef="disciplina">
          <th mat-header-cell *matHeaderCellDef>Disciplina</th>
          <td mat-cell *matCellDef="let element">{{ element.disciplina }}</td>
        </ng-container>

        <ng-container matColumnDef="fecha">
          <th mat-header-cell *matHeaderCellDef>Fecha fin servicio</th>
          <td mat-cell *matCellDef="let element">
            <span
              [ngClass]=" element.fechaSuperior
                  ? 'permiteIngreso'
                  : 'noPermiteIngreso'
              "
            >
              {{ element.fechaFin | date: "dd-MM-yyyy" }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="estado">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let element">
            <label *ngIf="element.estado"> Activo </label>
            <label *ngIf="!element.estado"> Inactivo </label>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</mat-dialog-content>
